import {
    InfoConfigAutoUpdateManagerService
} from "@nms-ng2/app/modules/device/info-config/info-config-auto-update-manager.service";
import { NmsToastrService } from "@nms-ng2/app/shared/components/elements/nms-toastr/nms-toastr.service";
import { PollingRequestClient } from "@nms-ng2/app/shared/models/polling-request-client";
import { TranslationHelperService } from "@nms-ng2/app/shared/services/util/translation-helper.service";

var app = angular.module("nms.dynamicDevice");

app.controller("DynamicDeviceController", [
    "$rootScope",
    "$scope",
    "$state",
    "NesDataCacheService",
    "DomainHandlerService",
    "NesRestService",
    "ContentManager",
    "LoadingPaneService",
    "$log",
    "NesEditConfigService",
    "DevicePermissionService",
    "$window",
    "NMS_STATES",
    "DropdownDeviceService",
    "$translate",
    "NodeInfoCacheManager",
    "NodeInfoCache",
    "UserPreferencesService",
    "$stateParams",
    "ListService",
    "SessionPreferencesService",
    "DevicePollingService",
    "monitoringSettings",
    "CPU_USAGE",
    "MEMORY_USAGE",
    "TreeFilterService",
    "TreeSelectionManager",
    "hasConfigPermission",
    "EquipmentsModalsActionsService",
    "NmsToastrService",
    "TranslationHelperService",
    "TEXT_FINDER_INFO_CONFIG",
    "InfoConfigAutoUpdateManagerService",
    function (
        $rootScope,
        $scope,
        $state,
        NesDataCacheService,
        DomainHandlerService,
        NesRestService,
        ContentManager,
        LoadingPaneService,
        $log,
        NesEditConfigService,
        DevicePermissionService,
        $window,
        NMS_STATES,
        DropdownDeviceService,
        $translate,
        NodeInfoCacheManager,
        NodeInfoCache,
        UserPreferencesService,
        $stateParams,
        ListService,
        SessionPreferencesService,
        DevicePollingService,
        monitoringSettings,
        CPU_USAGE,
        MEMORY_USAGE,
        TreeFilterService,
        TreeSelectionManager,
        hasConfigPermission,
        EquipmentsModalsActionsService,
        nmsToastrService: NmsToastrService,
        translationHelperService: TranslationHelperService,
        TEXT_FINDER_INFO_CONFIG,
        InfoConfigAutoUpdateManagerService: InfoConfigAutoUpdateManagerService
    ) {
        $log.log("DeviceController: (" + Date.now() + ")");
        const CONTENT_MODIFIED_CANCEL_MODAL_NAME = "contentModifiedCancelModalName";
        const globalConfig = EquipmentsModalsActionsService.getDefaultGlobalConfig();
        const windowIdentifier = "configNodeForID=";
        const persistentProperties = ["path", "pathKeys"];

        $scope.dropdownTitle = $translate.instant($state.current.data.pageTitle);
        $scope.device = $stateParams.device;
        $scope.content = { modified: false };
        $scope.filters = SessionPreferencesService.getFilters();
        $scope.shortcuts = DropdownDeviceService.getShortcutToConfig(globalConfig);
        $scope.zabbixUrl = monitoringSettings.url;
        $scope.CPU_USAGE = CPU_USAGE;
        $scope.MEMORY_USAGE = MEMORY_USAGE;
        $scope.infoTooltip = $translate.instant("title.informationAccordionTooltip");
        $scope.configTooltip = $translate.instant("title.configurationAccordionTooltip");
        const placeHolderText = $translate.instant("search.info.config.placeholder")
            .replace("{0}", TEXT_FINDER_INFO_CONFIG.MIN_TERM_SIZE);

        $scope.deviceTreeTextFinderConfig = {
            id: "tree-text-finder-input",
            filterContent: function (event, isFirstPolling) {
                const isPolling = event.name === "deviceLoaded" && !isFirstPolling;
                TreeFilterService.filter($scope.deviceTreeTextFinderConfig.searchTerm, isPolling);
            },
            searchableElementSelector: ".searchable-element",
            enabled: false,
            performSearchOnEvents: ["deviceLoaded"],
            clearSearch: function (event, isFirstPolling) {
                if (_.get(event, "name") !== "deviceLoaded" || isFirstPolling) {
                    TreeFilterService.clearSearch();
                }
            },
            baseElementSelector: ".tree",
            minTermSize: TEXT_FINDER_INFO_CONFIG.MIN_TERM_SIZE,
            placeholder: placeHolderText,
            hotkey: {
                combo: "ctrl+shift+f",
                description: placeHolderText,
                callback: function () {
                    angular.element("#" + $scope.deviceTreeTextFinderConfig.id).focus();
                }
            }
        };

        $scope.autoUpdaterId = "dynamic-device-auto-updater";

        const closeLoadingPane = function () {
            LoadingPaneService.closeLoadingPane();
        };

        const onActivationCallback = function () {
            LoadingPaneService.updateLoadingPane("nes.services.config.retrieving");
        };

        const initStructure = function () {
            $scope.data = NesDataCacheService.getCurrentData();
            $scope.schema = NesDataCacheService.getSchema();
            NodeInfoCacheManager.createNodeInfoCache($scope.schema);

            /* FIXME: Devido a natureza assincrona da busca em cima de um webworker alguns problemas surgiram:
             *
             * - Quando um elemento de uma lista é removido via CLI e um polling é solicitado
             *   existe um lag entre a árvore ser atualizada, onde os pais do elemento ficam por algum tempo presentes na árvore
             *
             * - Quando um elemento é adicionado via CLI um comportamento semelhante ocorre, onde a árvore permanece vazia por
             *   um periodo até que o filtro seja realizado
             */
            TreeFilterService.init().then(function () {
                $scope.$broadcast("deviceLoaded", isFirstPolling);
            });
            processPathAndSetContent($scope.schema);
        };

        const permissionAction = function () {
            $scope.showViewOnlyBanner = false;
            $rootScope.readOnly = false;
            $rootScope.hasPermission = true;
            const onDataRetrievedCallback = function () {
                deviceRequestFinishedCallback();
                closeLoadingPane();
            };
            const onSchemaRetrievedCallback = function () {
                NesDataCacheService.reloadData($scope.device.id, onDataRetrievedCallback);
            };

            NesDataCacheService.loadSchema($scope.device.id, onSchemaRetrievedCallback);
            $rootScope.$emit("title:append", $scope.device.name);
            $rootScope.$broadcast("updateDeviceHeaderByDeviceId", $scope.device.id);
        };

        const noPermissionAction = function () {
            $scope.showViewOnlyBanner = false;
            $rootScope.readOnly = true;
            $rootScope.hasPermission = false;
        };

        const readOnlyAction = function () {
            permissionAction();
            $rootScope.readOnly = true;
            $scope.showViewOnlyBanner = true;
        };

        const openDeviceOnPath = function (path) {
            ContentManager.clear();
            $state.params.path = path;
            processPathAndSetContent($scope.schema);
        };

        const resolveDevice = function() {
            return InfoConfigAutoUpdateManagerService.resolveDeviceId($scope.device.id);
        };

        $scope.init = function () {
            const pollingClient = PollingRequestClient.INFO_CONFIG;
            InfoConfigAutoUpdateManagerService.create();
            InfoConfigAutoUpdateManagerService.getRefreshInterval((interval) => $scope.interval = interval);
            InfoConfigAutoUpdateManagerService.setup([$scope.device.id], pollingClient, resolveDevice.bind(this));
            NesDataCacheService.clear();
            NodeInfoCacheManager.clear();
            ContentManager.clear();
            TreeFilterService.clearSearch();

            $scope.shortcuts = DropdownDeviceService.getShortcutToConfig(globalConfig, $scope.device, openDeviceOnPath);
        };

        $scope.tryOpenInfoConfig = function () {
            if (hasConfigPermission) {
                DevicePermissionService.checkPermissions($scope.device, permissionAction, readOnlyAction, noPermissionAction);
            } else {
                readOnlyAction();
            }
        };

        let isFirstPolling = true;
        const deviceRequestFinishedCallback = function () {
            $log.log("Request Finished");

            initStructure();
            $rootScope.$broadcast("reloadTreeNode");
            $scope.content.modified = false;
            isFirstPolling = false;
        };

        $scope.$on("CONTENT_MODIFIED", function (event, newValue) {
            if (!$rootScope.readOnly) {
                $scope.content.modified |= newValue;
            }
        });

        const processPathAndSetContent = function (deviceContainer) {
            let content = null;

            if ($state.params.path) {
                content = getContent($state.params.path, null, true, true);
            } else if (ContentManager.getNode()) {
                const node = ContentManager.getNode();
                const pathKeys = ContentManager.getPathKeys();

                content = getContent(node.paths.schemaJsonPath, pathKeys, false, false);
            } else if ($state.params.fullPath) {
                const resolvedPathKeys = DomainHandlerService.resolveRequiredPathKeys(
                    $state.params.fullPath,
                    $state.params.pathKeys
                );
                content = getContent($state.params.fullPath, resolvedPathKeys, true, true);
            } else {
                const nodePath = UserPreferencesService.loadPreferences(
                    {},
                    windowIdentifier + $scope.device.id,
                    persistentProperties
                );

                if (!_.isEmpty(nodePath)) {
                    content = getContent(nodePath.path, nodePath.pathKeys, false, true);

                    const sessionKeys = nodePath.keys;
                    const nodeKeys = content ? getNodeKeysValues(content.node, content.keys) : "";

                    content = !sessionKeys || sessionKeys === nodeKeys ? content : null;
                }
            }

            setContent(content, deviceContainer);
        };

        const setContent = function (content, deviceContainer) {
            if (content === null) {
                content = {
                    node: deviceContainer,
                    canonicalPath: "/",
                    path: "$"
                };
            }

            ContentManager.clear();
            clearStateParams();
            ContentManager.setContent(content);
        };

        const clearStateParams = function () {
            $state.params.fullPath = null;
            $state.params.pathKeys = null;
        };

        const isListNodePath = function (schemaJsonPath) {
            const parts = schemaJsonPath.split(".");
            if (parts[parts.length - 3] === "lists") {
                return true;
            }

            return false;
        };

        const getContent = function (schemaJsonPath, pathKeys, setFilters, refreshTree) {
            let content = null;
            const node = DomainHandlerService.getSchemaNode(schemaJsonPath);
            const dataNode = DomainHandlerService.getDataNodeForSchemaNode(node, pathKeys);

            const isList = isListNodePath(schemaJsonPath);

            /*
             * No caso de links externos (links da GPON ONUs, Summary, atalhos de dropdown para nós especificos da Info/Config),
             * uma mensagem de erro é exibida quando um item de lista não existe mais na configuração do device.
             * Nesses casos, o nome do nó na mensagem de erro é definido no atributo displayName e enviado para o $state.params.
             */
            if (isList && dataNode == null) {
                handlePathNotFoundError($state.params.displayName);
                return null;
            }

            let keys = [];
            let canonicalPath = "/";

            if (node.parentPaths.schemaJsonPath) {
                const schemaNode = isList ? DomainHandlerService.getSchemaNode(node.parentPaths.schemaJsonPath) : node;

                canonicalPath = DomainHandlerService.getPath(schemaNode);
                const cachedNode = NodeInfoCache.getNode(canonicalPath);
                keys = ListService.getKeyNames(cachedNode);

                if (setFilters) {
                    $scope.filters.showConfig = $scope.filters.showConfig || cachedNode.isConfiguration;
                    $scope.filters.showStatus = $scope.filters.showStatus || !cachedNode.isConfiguration;
                }
            }

            content = {
                node: node,
                path: schemaJsonPath,
                refreshTree: refreshTree,
                canonicalPath: canonicalPath,
                keys: keys,
                pathKeys: pathKeys
            };

            return content;
        };

        const getNodeKeysValues = function (node, keys) {
            if (node && keys) {
                const nodeKeyValues = ListService.getListKeyValues(node.leaves, keys);
                return _.pluck(nodeKeyValues, "value").join(";");
            }

            return "";
        };

        const handlePathNotFoundError = function (displayName) {
            if (displayName) {
                $rootScope.showDialog({
                    translateKey: "device.pathNotFound",
                    params: [$state.params.displayName],
                    paramsInsideMessage: true
                });
            }
        };

        const hasChangesToDiscard = function () {
            return $scope.content.modified;
        };

        const popupConfirmDiscardChanges = function (actionOnConfirmDiscard) {
            // TODO: [US54236][SETH]Implementar esta função de modo genérico que possa ser chamada de qualquer lugar do sistema

            const isUserLoggedOff = localStorage.getItem("isAuthenticated") !== "true";
            if (!hasChangesToDiscard() || isUserLoggedOff) {
                leavePage(actionOnConfirmDiscard);
            } else {
                $rootScope
                    .showDialog({
                        translateKey: "device.discardChanges",
                        isConfirm: true,
                        ngDialogOptions: {
                            name: CONTENT_MODIFIED_CANCEL_MODAL_NAME
                        }
                    })
                    .then(function () {
                        leavePage(actionOnConfirmDiscard);
                    });
            }
        };

        const leavePage = function (actionOnConfirmDiscard) {
            UserPreferencesService.saveExitValue(windowIdentifier + $scope.device.id, "true");
            TreeSelectionManager.clear();
            setDeviceContextToSessionStorage();
            ContentManager.clear();
            actionOnConfirmDiscard();
        };

        const setDeviceContextToSessionStorage = function () {
            const schemaNode = ContentManager.getNode();

            if (schemaNode) {
                const schemaPath = schemaNode.paths.schemaJsonPath;
                const pathKeys = ContentManager.getPathKeys();
                const properties: any = { path: schemaPath, pathKeys };

                UserPreferencesService.savePreferences(properties, windowIdentifier + $scope.device.id, persistentProperties);
            }
        };

        const configurationChangedCallback = function () {
            const message = translationHelperService.translate("device.configHashHasChanged");
            nmsToastrService.error(message);
            deviceRequestFinishedCallback();
        };

        const handleFinishedPoll = function (deviceId) {
            // TODO: Reavaliar lógica ao carregar a página.
            // Do jeito que está, são feitas duas chamadas de getDevice para o NES ao abrir a página.
            // Uma ao abrir e outro pelo timer
            const onCacheUpdateAndActivationCallback = function () {
                deviceRequestFinishedCallback();
                closeLoadingPane();
            };

            $rootScope.$broadcast("updateDeviceHeaderByDeviceId", $scope.device.id);

            if ($scope.content.modified) {
                NesDataCacheService.reloadDataIfConfigurationChanged(deviceId, configurationChangedCallback, closeLoadingPane);
            } else {
                NesDataCacheService.reloadData(deviceId, onCacheUpdateAndActivationCallback);
            }
        };

        $scope.requestPolling = function () {
            DevicePollingService.requestPolling($scope.device.id);
        };

        $scope.notifyTableUpdateData = function(response) {
            handleFinishedPoll(response.data);
        }

        $scope.startDevicePolling = function()  {
            return InfoConfigAutoUpdateManagerService.startDevicesPolling();
        }

        $scope.getFeedbackMessage = function() {
            return InfoConfigAutoUpdateManagerService.getFeedbackMessage();
        }

        const confirmAndApply = function (response) {
            let translateKey = (!$rootScope.currentFormIsInvalid)
                             ? "device.applyChanges"
                             : "device.applyChangesWithWarning"

            $rootScope
                .showDialog({
                    translateKey: translateKey,
                    isConfirm: true
                })
                .then(function () {
                    LoadingPaneService.showLoadingPane("device.applyingConfiguration");

                    const onSuccessCallback = function () {
                        const message = translationHelperService.translate("nes.services.config.applySuccess");
                        nmsToastrService.success(message);
                    };

                    const onCacheUpdateCallback = deviceRequestFinishedCallback;

                    NesEditConfigService.editConfig(
                        response,
                        onActivationCallback,
                        onCacheUpdateCallback,
                        onSuccessCallback,
                        closeLoadingPane
                    );
                });
        };

        const verifyChangesAndApply = function () {
            const applyConfigurationPromise = NesRestService.createPatchOfOperations(
                NesDataCacheService.getOriginalData(),
                NesDataCacheService.getCurrentData()
            );

            applyConfigurationPromise.then(function (response) {
                if (_.isEmpty(response.operations)) {
                    const message = translationHelperService.translate("device.noChanges");
                    nmsToastrService.info(message);
                } else {
                    confirmAndApply(response);
                }
            });

            applyConfigurationPromise.catch(function () {
                const message = translationHelperService.translate("device.checkForConfigChangesFailed");
                nmsToastrService.error(message);
            });
        };

        $scope.submit = function () {
            if ($rootScope.readOnly || !$scope.hasPermission) {
                const message = translationHelperService.translate("device.applyChangesNotPermission");
                nmsToastrService.error(message);
                return;
            }

            verifyChangesAndApply();
        };

        $scope.cancel = function () {
            popupConfirmDiscardChanges(function () {
                $state.go(NMS_STATES.manageDevices);
            });
        };

        $scope.doLogoff = function () {
            popupConfirmDiscardChanges(function () {
                $rootScope.doLogoff();
            });
        };

        $scope.hideBanner = function () {
            $scope.showViewOnlyBanner = false;
        };

        $scope.$watch("content.modified", function (newValue) {
            const modified = !!newValue;

            if (modified) {
                InfoConfigAutoUpdateManagerService.pause($scope.autoUpdaterId);
            }
        });

        $scope.$on("$stateChangeStart", function (event, toState, toParams) {
            if (UserPreferencesService.loadExitValue(windowIdentifier + $scope.device.id) !== "true") {
                event.preventDefault();
                popupConfirmDiscardChanges(function () {
                    $state.go(toState, toParams);
                });
            }
            UserPreferencesService.saveExitValue(windowIdentifier + $scope.device.id, "false");
        });

        $scope.onConfigInfoFilterChange = function () {
            $rootScope.$broadcast("reloadContent");
        };

        $scope.toggleFilters = function () {
            $scope.filters.showStatus = !$scope.filters.showStatus;
            $scope.filters.showConfig = !$scope.filters.showConfig;
        };

        $scope.$watch("device", function () {
            $scope.tryOpenInfoConfig();
        });

        $scope.$watch(
            function () {
                return localStorage.getItem("username");
            },
            function (newValue, oldValue) {
                if (newValue != null && newValue !== oldValue) {
                    $rootScope
                        .showDialog({
                            translateKey: "device.changesLost"
                        })
                        .closePromise.then(function () {
                            $state.current.ignoreConfirmation = true;
                            $window.location.reload();
                        });
                }
            }
        );

        const unregisterUpdateWarningSettings = $rootScope.$watch("currentFormIsInvalid", function () {
            $scope.warningSettings = {
                show: $rootScope.currentFormIsInvalid,
                warnings: [
                    {
                        show: $rootScope.currentFormIsInvalid,
                        generalMessage: {
                            translateKey: "nes.services.config.invalidValues",
                        }
                    }
                ]
            }
        });

        $scope.$on("$destroy", function() {
            unregisterUpdateWarningSettings();
            InfoConfigAutoUpdateManagerService.destroy();
        });

        $scope.init();
    }
]);
